import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pdf-viewer-btn-container"
}

import { VuePDF, usePDF } from "@tato30/vue-pdf";
import { ref } from "vue";
import { computed } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewPdf',
  props: {
    pdfUrl: {}
  },
  setup(__props: any) {

const props = __props;



const page = ref(1);
const {
  value: { pdf, pages },
} = computed(() => usePDF(props.pdfUrl!));

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(pages) > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (page.value = page.value > 1 ? page.value - 1 : page.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Prev")
            ]),
            _: 1
          }),
          _createElementVNode("span", null, _toDisplayString(page.value) + " / " + _toDisplayString(_unref(pages)), 1),
          _createVNode(_component_v_btn, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (page.value = page.value < _unref(pages) ? page.value + 1 : page.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Next")
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(VuePDF), {
      pdf: _unref(pdf),
      page: page.value,
      class: "pdf-viewer"
    }, null, 8, ["pdf", "page"])
  ], 64))
}
}

})